<template>
    <div class="VotingResult">
        <div class="alert alert-success">
            Su voto fue procesado exitosamente, Gracias.
        </div>
    </div>
</template>

<script>
export default {
    name:'VotingResult',
    props: {        
        InfoRange: Object
    }
}
</script>

<style scoped>

</style>